// Registrasi Tabung (`/operations/register`): only at the owner warehouse, phone first.
// Formal and calm, like the rest of the app: "Reader" (never "gateway"), no exclamation marks.

/** The one cylinder type registered here, sent with every registration (never "CNG 3 kg"). */
export const CAPACITY_DEFAULT = 'Setara LPG 3 kg';

export const REGISTER = {
  sub: (warehouse: string) => `Hanya di ${warehouse}`,
  onlyTitle: (warehouse: string) => `Pendaftaran hanya di ${warehouse}`,
  onlyBody: (here: string | undefined, warehouse: string) => `Anda bertugas di ${here ?? 'lokasi lain'}. Tabung baru didaftarkan oleh petugas ${warehouse}.`,
  loading: 'Mencari tag di depan Reader…',
  // the tag card
  waitTitle: 'Dekatkan tag ke Reader',
  waitBody: 'Tag yang belum terdaftar muncul di sini secara otomatis.',
  offlineTitle: 'Reader terputus',
  offlineBody: 'Pendaftaran menunggu sampai Reader tersambung kembali. Periksa listrik dan jaringan Reader.',
  tagRead: 'Tag terbaca',
  leftReader: 'sudah tidak di depan Reader',
  tidMissing: 'belum terbaca',
  ready: 'Belum terdaftar · siap didaftarkan',
  tidWait: 'Menunggu ID chip (TID) terbaca. Dekatkan tag lebih lama ke Reader.',
  staleLine: 'Tag tidak lagi terbaca; dekatkan kembali ke Reader',
  blockedLine: 'Tag ini belum dapat didaftarkan. Dekatkan kembali ke Reader.',
  // a tag refused for good: a tag is bound to one cylinder, once
  usedTitle: (serial: string) => `Tag ini sudah pernah dipakai tabung ${serial}`,
  usedBody: 'Satu tag hanya dapat dipakai untuk satu tabung. Pasang tag baru, lalu dekatkan ke Reader.',
  retiredTitle: 'Tag ini sudah tidak berlaku',
  retiredBody: 'Tag yang sudah diganti atau milik tabung yang dihapus tidak dapat dipakai lagi. Gunakan tag baru.',
  usedShort: (serial: string) => `Pernah dipakai ${serial}`,
  retiredShort: 'Tidak berlaku',
  tidShort: 'Menunggu TID',
  blockedShort: 'Belum dapat didaftarkan',
  notThis: 'Bukan tag ini',
  othersToo: (n: number) => `${n} tag lain juga terbaca.`,
  alreadyTitle: 'Tag ini sudah terdaftar',
  alreadyAs: 'Terdaftar sebagai',
  openCylinder: 'Lihat tabung',
  severalTitle: 'Lebih dari satu tag terbaca',
  severalBody: 'Dekatkan satu tag saja, atau pilih tag yang akan didaftarkan.',
  pick: 'Pilih',
  savedLabel: 'Nomor seri tabung baru',
  savedHint: 'Tulis atau tempel nomor ini di badan tabung.',
  readError: (e: string) => `Pembacaan Reader belum dapat dimuat. ${e}`,
  staleError: (e: string) => `Daftar tag mungkin belum terbaru. ${e}`,
  // the form
  dataTitle: 'Data tabung',
  typeFact: 'Tipe 4 (komposit)',
  made: 'Tanggal produksi',
  due: 'Uji berkala berikutnya',
  unset: 'Belum diisi',
  remembered: 'Tanggal diingat untuk tabung berikutnya.',
  dueAfterMade: 'Harus setelah tanggal produksi.',
  madeIncomplete: 'Lengkapi tanggal, bulan, dan tahun produksi, atau kosongkan ketiganya.',
  madeFuture: 'Tanggal produksi tidak boleh setelah hari ini.',
  dueIncomplete: 'Lengkapi tanggal, bulan, dan tahun uji berkala berikutnya, atau kosongkan ketiganya.',
  serialAuto: (warehouse: string) => `Nomor seri dibuat otomatis saat disimpan dan tabung langsung tercatat di ${warehouse}.`,
  // this session
  sessionTitle: 'Terdaftar sesi ini',
  sessionCount: (n: number) => `${n} tabung`,
  sessionMore: (n: number) => `dan ${n} tabung lainnya`,
  // the footer
  save: 'Simpan & daftarkan berikutnya',
  saved: (serial: string) => `Terdaftar sebagai ${serial}`,
  needTag: 'Dekatkan tag ke Reader',
  needReader: 'Reader terputus',
  needNetwork: 'Tidak ada koneksi internet',
  needOne: 'Dekatkan satu tag saja',
  alreadyReason: 'Tag sudah terdaftar',
  usedReason: (serial: string) => `Tag sudah pernah dipakai ${serial}`,
  retiredReason: 'Tag sudah tidak berlaku',
  staleReason: 'Tag tidak lagi terbaca',
  tidReason: 'Menunggu ID chip (TID) terbaca',
  blockedReason: 'Tag belum dapat didaftarkan',
  ready2: 'Siap disimpan',
} as const;
